var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E1F3E1",
    d: "M1.6 3.2H16V21.599999999999998H1.6z",
    transform: "translate(-25 -186) translate(0 56) translate(0 122) translate(25 8) translate(7 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#373A37",
    strokeWidth: 1.6,
    d: "M4.8 18.4H12.8V22.4H4.8z",
    transform: "translate(-25 -186) translate(0 56) translate(0 122) translate(25 8) translate(7 4)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373A37",
    strokeWidth: 0.8,
    d: "M4.4 5.2H7.6000000000000005V6.2H4.4zM4.4 8.4H7.6000000000000005V9.4H4.4zM10 5.2H13.2V6.2H10zM10 8.4H13.2V9.4H10zM4.4 11.6H7.6000000000000005V12.6H4.4zM10 11.6H13.2V12.6H10zM4.4 14.8H7.6000000000000005V15.8H4.4zM10 14.8H13.2V15.8H10z",
    transform: "translate(-25 -186) translate(0 56) translate(0 122) translate(25 8) translate(7 4)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373A37",
    strokeWidth: 1.6,
    d: "M0.8 2.4H16.8V22.4H0.8z",
    transform: "translate(-25 -186) translate(0 56) translate(0 122) translate(25 8) translate(7 4)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373A37",
    strokeWidth: 0.8,
    d: "M0.4 0.4H5.2V1.4H0.4z",
    transform: "translate(-25 -186) translate(0 56) translate(0 122) translate(25 8) translate(7 4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSites);
export default __webpack_public_path__ + "static/media/menu-sites.10ff4d4fbd8447ab6910d2e477d9479b.svg";
export { ForwardRef as ReactComponent };